export const getTokenUsingSocialMutation = /* GraphQL */ `
    mutation login($loginType: SocialLoginType!, $token: String!) {
        generateCustomerTokenBySocialLogin(type: $loginType, token: $token) {
            token
            reset_password
        }
    }
`
